import { Component, OnInit } from '@angular/core';
import { HttpDynamicService } from '../../../service/http-dynamic.service';
import { DynamicEntityDto } from '../../../service/dto';

@Component({
  selector: 'app-dynamic-entity-list',
  standalone: false,
  templateUrl: './dynamic-entity-list.component.html',
  styleUrl: './dynamic-entity-list.component.scss'
})
export class DynamicEntityListComponent implements OnInit{
	data: DynamicEntityDto[] = [];
	constructor(private httpService: HttpDynamicService){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}
}
